// extracted by mini-css-extract-plugin
export default {"galleryGrid3x3":"GalleryGrid3x3_galleryGrid3x3__YTg+B"};